<template>
  <v-card>
  <v-row class="floatrow">
    <v-btn
      v-if="stores.length < maxStores"
      color="secondary"
      class="new_button"
      @click="openCreate"
      title="Nouvel emplacement"
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>
    <v-dialog v-model="dialog" max-width="600px">
      <v-card class="modern-card">
        <v-card-title class="dialog-title">
          <v-icon left color="primary">mdi-store</v-icon>
          {{ form_title }}
        </v-card-title>
        <v-card-text class="dialog-content">
          <v-row>
            <v-col cols="12">
              <v-text-field
                label="Nom *"
                required
                v-model=store.name
                outlined
                dense
                prepend-inner-icon="mdi-store"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                label="Téléphone *"
                required
                v-model=store.phone
                outlined
                dense
                prepend-inner-icon="mdi-phone"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                label="E-mail *"
                required
                v-model=store.email
                outlined
                dense
                prepend-inner-icon="mdi-email"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                label="Adresse"
                required
                v-model=store.address
                outlined
                dense
                prepend-inner-icon="mdi-map-marker"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="dialog-actions">
          <v-spacer></v-spacer>
          <v-btn text @click="close" class="cancel-btn">Annuler</v-btn>
          <v-btn
            color="secondary"
            @click="save"
            :loading="loading"
            :disabled="loading"
            class="save-btn"
          >
            <v-icon left small>mdi-check</v-icon>
            Enregistrer
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
    <v-card-title>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Rechercher"
        single-line
        hide-details
        class="tablesearch"
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="stores"
      :search="search"
    >
    <template v-slot:item.rate_id="{ item }">
    {{ getRateLabel(item.rate_id) }}
    
    </template>
      <template v-slot:item.actions="{ item }">
    <v-icon
        small
        class="mr-2 edit_button"
        @click="edit(item)"
      >
        mdi-pencil
      </v-icon>
    </template>
    </v-data-table>
  </v-card>
</template>

<script>
	import store from '@/store/index.js';
  export default {
    props: {
      stores: [],
      business: [],
    },
    methods: {
      edit: function(item){
        this.index = this.stores.indexOf(item)
        this.store = Object.assign({}, item)
        this.form_title = "Editer Magasin : "+this.store.name
        this.dialog = true
      },
      openCreate: function(){
        this.reset()
        this.form_title = 'Nouvel emplacement (' + this.stores.length + '/' + this.maxStores + ')'
        this.dialog = true
      },
      getRateLabel: function(rate_id){
        if(rate_id == 1){
          return "HTG"
        }else{
          return 'USD'
        }
      },
      close: function(){
        this.dialog = false
        this.reset()
        this.loading = false
      },
      validateData: function(){
        if(this.store.name == ""){
          alert("Vous devez un nom pour le magasin")
          return false  
        }

        if(this.store.phone == ""){
          alert("Vous devez indiquer une téléphone")
          return false
        }

        if(this.store.email == ""){
          alert("Vous devez choisir un email")
          return false
        }

        if(this.store.address == ""){
          alert("Vous devez choisir une adresse")
          return false
        }

        return true;
      },
      save: function(){
        var self = this;
        if(this.validateData()){
          this.loading = true
          var url = ''
          if (this.index > -1) { 
            url = '/stores/'+this.store.id
            this.$axios.put(url+"?data="+encodeURIComponent(JSON.stringify(self.store)))
            .then(response => {
              Object.assign(self.stores[self.index], response.data)
              self.dialog = false
              self.loading = false
              self.reset()
            })
          }else{
            url = '/stores'
            this.store.user_id = parseInt(store.getters.StateUser.id)
            this.store.business_id = this.business.id
            this.$axios.post(url+"?data="+encodeURIComponent(JSON.stringify(self.store)))
            .then(response => {
              var created = response.data && response.data.data ? response.data.data : response.data
              self.stores.push(created);
              self.dialog = false
              self.loading = false
              self.reset()
            })
            .catch(error => {
              self.loading = false
              var msg = error.response && error.response.data && error.response.data.message
                ? error.response.data.message
                : "Échec de la création de l'emplacement"
              alert(msg)
            })
          }
        }
      },
      reset: function(){
        this.store = {
          name: '', 
          address: '', 
          phone: '', 
          email: ''
        }
        this.index = -1
        this.form_title = 'Nouveau MAgasin'
      }
    },
    data () {
      return {
        search: '',
        loading: false,
        dialog:'',
        index: -1,
        maxStores: 5,
        form_title: 'Nouveau Magasin',
        store: {
          name: '', 
          address: '', 
          phone: '', 
          email: ''
        },
        headers: [
          {
            text: 'NOM',
            align: 'start',
            sortable: false,
            value: 'name',
          },
          { text: 'TELEPHONE', value: 'phone' },
          { text: 'E-MAIL', value: 'email' },
          { text: 'ADRESSE', value: 'address' },
          { text: 'DEVISE DE VENTE', value: 'rate_id' },
          { text: 'ACTIONS', value: 'actions' },
        ],
    }
  }
}
</script>
<style type="text/css">
	.tablesearch .v-input__slot:before{
    display:none;
  }
 .floatrow{
  text-align: right;
   float: right;
   margin-right: 21px;
   margin-left: 5px;
  }
  .tablesearch .v-input__control{
    border: 1px solid #ddd;
    padding: 5px 10px;
  }
  .edit_button{
    font-size: 16px;
    padding: 5px;
    background: #003f74 !important;
    color: white!important;
    border-radius: 4px;
  }

  .new_button{
    width:50px;
    margin-top:44px!important;
    float:right;
    border-radius:1px;
    height:44px;
  }

  .view_button{
    font-size: 16px;
    padding: 5px;
    background: #fb8c00 !important;
    color: white!important;
    border-radius: 4px;
  }
  td.text-start:last-child, th.text-start:last-child{
    text-align:right!important;
  }
  .v-dialog .v-card__title{
    background:#f3f3f3;
    border-bottom:1px solid #ddd;
  }
  .v-btn.close_modal_button{
    background-color:#1976d2!important;
    color:white!important;
  }
  .v-btn.confirm_modal_button{
    background-color:#4caf50!important;
    color:white!important;
  }

  .v-dialog .v-card__actions{
    padding-bottom: 15px!important;
    padding-top: 15px!important;
    background: #f3f3f3;
    border-top: 1px solid #ddd;
  }
  .v-card__actions .v-progress-circular{
    margin-top:1px !important;
  }
    .v-card__actions .v-progress-circular circle{
      color:white!important;
    }
</style>